export const ActionTypes = {
    SET_CONTACTS: 'SET_CONTACTS',
};

export const initialState = {
    contacts: []
};

// Rename to avoid confusion with the main appReducer
export function reducer(state, action) {
  switch (action.type) {
    case ActionTypes.SET_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      };
    default:
      return state;
  }
}